import { Popover } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import ClearFilters from "../../../../assets/customSVG/ClearFilters";

// hooks && helpers
import { useSearch } from "hooks/useSearch";
import { cn } from "../../../../helper/cn";
import {
  useAspDispatch,
  useAspSelector,
} from "../../../../test/jest-redux-hooks";

// commonComponents && constants
import CheckBoxSqure from "../../../../components/commonComponents/checkbox/CheckBoxSqure";
import SearchBar from "../../../../components/commonComponents/searchBar";
import { TEAM_STATUS_LIST, TEAMS_ROLE } from "../../constants/home";

// api
import {
  activateApi,
  cancelInvitationAPi,
  createTeamNameApi,
  deleteTeamMembersApi,
  deleteTeamsApi,
  getRolesApi,
  getTeamMembersApi,
  getTeamsApi,
  teamInviteApi,
  teamInviteUpdateApi,
  updateScreenNameApi,
  updateTeamsApi,
} from "../../api/Api";

// query
import { useQuery, useQueryClient } from "@tanstack/react-query";

// components
import { updateToggleToast } from "../../../../reduxToolkit/appSlice";
import CreateTeamModal from "./CreateTeamModal";
import TeamsList from "./TeamsList";
import { ManagementRoles } from '../../../../constant/app/RolebasedAccess';

const TeamCreation = ({ activeNav }) => {
  const dispatch = useAspDispatch();
  const {
    searchKey,
    setSearchKey,
    onChange: onSearchChange,
    debouncedSearchKey,
  } = useSearch("");
  const { currentBrand, toggleToast, brandUserRoles, isAccountOwner, currentUser } = useAspSelector(
    (state) => state?.app
  );
  let isManagementUser = false;
    if (isAccountOwner) {
      isManagementUser = true;
    } else {
      brandUserRoles.forEach((bur) => {
        if (ManagementRoles.includes(bur.role)) {
          isManagementUser = true;
        }
      });
    }
  const queryClient = useQueryClient();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [newTeamName, setNewTeamName] = useState("");
  const [multipleLeaders, setmultipleLeaders] = useState([]);
  const [multipleMembers, setmultipleMembers] = useState([]);
  const [showRoles, setShowRoles] = useState([]);
  const [activeTeam, setActiveTeam] = useState(null);
  const [team_role, setTeamsRoleList] = useState(null);
  const [selectedRoleId, setSelectedRoleId] = useState([]);
  const [team_status, setTeamStatus] = useState(null);
  const [team_statusId, setTeamStatusId] = useState([]);

  const [creationError, setCreationError] = useState("");
  const [editDeletePopover, setEditDeteletePopover] = useState(false);
  const [updateTrue, setUpdateTrue] = useState(false);
  const [editingTeamId, setEditingTeamId] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [inputValue, setInputValue] = useState([]);

  useEffect(() => {
    setTeamsRoleList(TEAMS_ROLE);
    setTeamStatus(TEAM_STATUS_LIST);
  }, []);

  const onRoleChange = (data) => {
    const res = team_role?.map((s) => {
      if (s?.id === data?.id) {
        return { ...s, isSelected: !s?.isSelected };
      }
      return s;
    });
    const filterValues = res?.filter((item) => item?.isSelected);

    setSelectedRoleId(filterValues);
    setTeamsRoleList(res);
  };

  const onTeamsStatusChange = (data) => {
    const res = team_status?.map((s) => {
      if (s?.id === data?.id) return { ...s, isSelected: !s?.isSelected };
      return s;
    });
    setTeamStatusId(res?.filter((t) => t?.isSelected));
    setTeamStatus(res);
  };

  const allowAllClear = useCallback(() => {
    return selectedRoleId?.length > 0 || team_statusId?.length > 0;
  }, [selectedRoleId, team_statusId]);

  const clearRoleList = () => {
    const res = team_role?.map((t) => {
      return { ...t, isSelected: false };
    });

    setSelectedRoleId([]);
    setTeamsRoleList(res);
  };

  const handleSelect = (option) => {
    setmultipleMembers((prev) => {
      const alreadySelected = prev.some(
        (item) => item?.id === option?.id
      );
      if (alreadySelected) return prev;
      return [...prev, option];
    });
  };

  const handleSelectLeader = (option) => {
    setmultipleLeaders((prev) => {
      const alreadySelected = prev.some(
        (item) => item?.id === option?.id
      );
      if (alreadySelected) return prev;
      return [...prev, option];
    });
  };

  const showModal = () => {
    setIsModalVisible(true);
    setCurrentStep(1);
    setEditDeteletePopover(false);
    getRolesApi(currentBrand?.brand_id).then((res) => {
      if (res?.status === 200) {
        setShowRoles(res?.data);
      }
    });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setNewTeamName("");
    setmultipleLeaders([]);
    setmultipleMembers([]);
    setCreationError("");
    setUpdateTrue(false);
  };

  const removeMembers = (removedValue) => {
    setmultipleMembers(
      multipleMembers.filter((value) => value !== removedValue)
    );
  };

  const removeLeaders = (removedValue) => {
    setmultipleLeaders(
      multipleLeaders.filter((value) => value !== removedValue)
    );
  };

  const handleCreate = () => {
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      name: newTeamName,
      role_ids: brandUserRoles?.map((role) => role.role_id),
      user_id: currentUser?.id,
    };
    console.log({currentBrand});
    console.log({payLoad});
    console.log({currentUser});
    console.log({brandUserRoles});

    createTeamNameApi(currentBrand?.brand_id, payLoad)
      .then((res) => {
        if (res?.status === 201) {
          setEditingTeamId(res?.data?.data?.team?.id);
          queryClient.invalidateQueries({
            queryKey: ["teamsList", currentBrand?.brand_id],
            exact: false,
          });
          setCurrentStep(2);
        }
      })
      .catch((error) => {
        setCreationError(error?.response?.data?.error);
      });
  };

  const getTeamsList = useQuery({
    queryKey: ["teamsList", currentBrand?.brand_id, debouncedSearchKey],
    queryFn: () => getTeamsApi(currentBrand?.brand_id, debouncedSearchKey),
    enabled: !!currentBrand?.brand_id,
  });

  const getTeamMembers = useQuery({
    queryKey: [
      "teamsMembers",
      activeTeam,
      currentBrand?.brand_id,
      {
        filter_role: selectedRoleId?.map((item) => item?.key),
        filter_status: team_statusId?.map((item) => item?.status),
      },
    ],
    queryFn: () => {
      return getTeamMembersApi(activeTeam, currentBrand?.brand_id, {
        filter_role: selectedRoleId?.map((item) => item?.key),
        filter_status: team_statusId?.map((item) => item?.status),
      });
    },
    enabled:
      !!currentBrand?.brand_id &&
      !!activeTeam &&
      !!selectedRoleId &&
      !!team_statusId,
  });

  const teamsData = getTeamsList?.data?.data?.data || [];
  const teamMembers = getTeamMembers?.data?.data?.data || [];

  const teamNameChcek = getTeamsList?.data?.data?.data?.filter(
    (t) => t?.name === newTeamName
  )?.[0]?.name;
  const isChecked = teamNameChcek !== newTeamName;
  const existingMemberMap = new Map(
    teamMembers.map((tm) => [tm.brands_users_roles_id, true])
  );

  const leaders = multipleLeaders
    ?.map((member) => {
      const id = updateTrue
        ? member.brands_users_roles_id || member?.id
        : member?.id;
      const existing = updateTrue && existingMemberMap.get(id);

      if (existing) {
        if (existing.status === 2 && existing?.status) {
          return { id: existing.id };
        } else {
          return null;
        }
      }

      return {
        brands_users_roles_id: id,
        screen_name: "",
        is_online: true,
        role_id: "8",
        email: member?.email,
        notes: "",
      };
    })
    ?.filter(Boolean);

  const members = multipleMembers
    ?.map((member) => {
      const id = updateTrue
        ? member.brands_users_roles_id || member?.id
        : member?.id;
      const existing = updateTrue && existingMemberMap.get(id);

      if (existing) {
        if (existing.status === 2) {
          return { id: existing.id };
        } else {
          return null;
        }
      }

      return {
        brands_users_roles_id: id,
        screen_name: "",
        is_online: true,
        role_id: "9",
        email: member?.email,
        notes: "",
      };
    })
    ?.filter(Boolean);

  const handleInvite = () => {
    const payLoad = {
      leader: leaders,
      member: members,
    };

    const inviteUpdate = updateTrue ? teamInviteUpdateApi : teamInviteApi;
    inviteUpdate(editingTeamId, currentBrand?.brand_id, payLoad)
      .then((res) => {
        if (res?.status === 201 || res?.status === 200) {
          handleCancel();
          queryClient.invalidateQueries({
            queryKey: ["teamsMembers", team?.id, currentBrand?.brand_id],
            exact: false,
          });
        }
      })
      .catch((error) => {
        setCreationError(error?.response?.data?.error);
      });
  };

  const handleUpdate = () => {
    const payLoad = {
      id: editingTeamId,
      brand_id: currentBrand?.brand_id,
      name: newTeamName,
      user_id: currentUser?.id,
    };

    if (isChecked) {
      updateTeamsApi(payLoad)
        .then((res) => {
          if (res?.status === 200) {
            setCurrentStep(2);
            queryClient.invalidateQueries({
              queryKey: ["teamsList", currentBrand?.brand_id],
              exact: false,
            });
          }
        })
        .catch((error) => {
          setCreationError(error?.response?.data?.error);
        });
    } else {
      queryClient.invalidateQueries({
        queryKey: ["teamsList", currentBrand?.brand_id],
        exact: false,
      });
      setCurrentStep(2);
    }
  };

  const clearTeamStatus = () => {
    const res = team_status?.map((t) => {
      return { ...t, isSelected: false };
    });

    setTeamStatusId([]);
    setTeamStatus(res);
  };

  const enableCreate = useCallback(() => {
    const isValidLeaders =
      multipleLeaders.length > 0 &&
      multipleLeaders.every((t) => [10, -2, 3, 1].includes(t?.status));

    return (
      (currentStep === 1 &&
        newTeamName.length > 0 &&
        !newTeamName.endsWith("'") &&
        !newTeamName.endsWith("-") &&
        !newTeamName.endsWith(".")) ||
      (currentStep === 2 && !isValidLeaders && multipleMembers.length > 0)
    );
  }, [newTeamName, currentStep, multipleLeaders, multipleMembers]);

  const handleDeleteTeams = (team) => {
    deleteTeamsApi(currentBrand?.brand_id, team?.id)
      .then((res) => {
        if (res?.status === 200) {
          queryClient.invalidateQueries({
            queryKey: ["teamsList", currentBrand?.brand_id],
            exact: false,
          });
          setActiveTeam(getTeamMembers?.data?.data?.data?.[0]?.id);
        }
      })
      .catch((error) => {
        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast?.length + 1,
              content: error?.response?.data?.error,
              status: "Error",
              duration: "",
            },
          ])
        );
      });
  };

  const handleRemoveMember = (team_member) => {
    deleteTeamMembersApi(
      currentBrand?.brand_id,
      team_member?.team_id,
      team_member?.brands_users_roles_id
    )
      .then((res) => {
        if (res?.status === 200) {
          queryClient.invalidateQueries({
            queryKey: ["teamsMembers", activeTeam, currentBrand?.brand_id],
            exact: false,
          });
        }
      })
      .catch((error) => {
        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast?.length + 1,
              content: error?.response?.data?.error,
              status: "Error",
              duration: "",
            },
          ])
        );
      });
  };
  const handleCancelInvitation = (team_member) => {
    cancelInvitationAPi(
      currentBrand?.brand_id,
      team_member?.team_id,
      team_member?.id
    )
      .then((res) => {
        if (res?.status === 200) {
          queryClient.invalidateQueries({
            queryKey: ["teamsMembers", activeTeam, currentBrand?.brand_id],
            exact: false,
          });
        }
      })
      .catch((error) => {
        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast?.length + 1,
              content: error?.response?.data?.error,
              status: "Error",
              duration: "",
            },
          ])
        );
      });
  };

  const handleEditTeams = (team) => {
    setIsModalVisible(true);
    setUpdateTrue(true);
    showModal();
    queryClient.invalidateQueries({
      queryKey: ["teamsMembers", team?.id, currentBrand?.brand_id],
      exact: false,
    });
    const teamLead = teamMembers?.filter((member) => member.role_id === 8);
    const members = teamMembers?.filter((member) => member.role_id === 9);

    setNewTeamName(team?.name);
    setEditingTeamId(team?.id);
    setmultipleLeaders(teamLead);
    setmultipleMembers(members);
  };

  const handleActivateTeams = (team) => {
    activateApi(team?.id, currentBrand?.brand_id)
      .then((res) => {
        if (res?.status === 200) {
          queryClient.invalidateQueries({
            queryKey: ["teamsList", currentBrand?.brand_id],
            exact: false,
          });
        }
      })
      .catch((error) => {
        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast?.length + 1,
              content: error?.response?.data?.error,
              status: "Error",
              duration: "",
            },
          ])
        );
      });
  };

  const updateScreenName = (l, result) => {
    const payLoad = {
      team_member_id: l?.id,
      team_id: l?.team_id,
      brands_users_roles_id: l?.brands_users_roles_id,
      screen_name: result,
    };
    updateScreenNameApi(currentBrand?.brand_id, payLoad).then((res) => {});
  };

  return (
    <>
      <CreateTeamModal
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        handleUpdate={handleUpdate}
        handleCreate={handleCreate}
        handleInvite={handleInvite}
        enableCreate={enableCreate}
        newTeamName={newTeamName}
        setNewTeamName={setNewTeamName}
        creationError={creationError}
        multipleLeaders={multipleLeaders}
        multipleMembers={multipleMembers}
        handleSelectLeader={handleSelectLeader}
        handleSelect={handleSelect}
        removeLeaders={removeLeaders}
        removeMembers={removeMembers}
        showRoles={showRoles}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        updateTrue={updateTrue}
        isChecked={isChecked}
      />

      <div className="w-full h-full bg-white rounded-2xl px-5">
        {activeNav === "Teams" && (
          <div className="w-[19.5%] flex-row align-center space-between pt-15">
            <span className="font18px-600 pr-2">Teams</span>
            {isManagementUser && (
                <div className="">
                  <button
                    className="font18px-500 text-white bg-[var(--new-primary)] px-3 b-radius-6 ml-20"
                    onClick={showModal}
                  >
                    + New
                  </button>
                </div>
              )}
          </div>
        )}

        <div className="w-100 flex  pb-3  border-b-[1px] items-center py-1">
          <SearchBar
            searchKey={searchKey}
            setSearchKey={setSearchKey}
            onChange={onSearchChange}
            loading={false}
            expandable={false}
            className="w-[15vw] mt-1 py-4 bg-[var(--channelButton)] "
          />

          <div className="flex items-center gap-3 pl-15">
            <Popover
              trigger={["click"]}
              arrow={false}
              placement="bottom"
              content={
                <div className="min-w-56 px-3.5 py-2.5">
                  <div className="w-full h-8 flex items-center justify-between gap-5 py-2.5 text-sm weight-medium">
                    <div className="text-[var(--font-400)]">Role</div>
                    <div
                      className={cn(
                        "text-[#F96056]",
                        selectedRoleId?.length > 0
                          ? "cursor-pointer opacity-100"
                          : "cursor-not-allowed opacity-50"
                      )}
                      onClick={() => {
                        if (selectedRoleId?.length > 0) clearRoleList();
                      }}
                    >
                      Clear
                    </div>
                  </div>
                  {team_role?.map((s) => {
                    return (
                      <div
                        className={cn(
                          "w-full h-12 flex items-center gap-2.5 py-1 cursor-pointer pl-10"
                        )}
                        onClick={() => {
                          onRoleChange(s);
                        }}
                        key={s?.id}
                      >
                        <CheckBoxSqure
                          value={s?.isSelected}
                          onChange={(e) => {}}
                          className="size-4"
                        />
                        <p>{s?.label}</p>
                      </div>
                    );
                  })}
                </div>
              }
            >
              <div className="group/goal bg-[var(--channelButton)] flex items-center gap-2 px-2 py-1.5 rounded-[0.4vw] cursor-pointer">
                <span className="campaign-filters flex items-center">Role</span>
                <div
                  className={cn(
                    "transition-transform duration-200 ease-linear"
                  )}
                >
                  <div
                    className={`border-[0.4vw] rounded-t-[0.2vw] border-transparent border-t-[#777] translate-y-[25%]`}
                  ></div>
                </div>
              </div>
            </Popover>

            <Popover
              trigger={["click"]}
              arrow={false}
              placement="bottom"
              content={
                <div className="min-w-56 px-3.5 py-2.5">
                  <div className="w-full flex items-center justify-between gap-5 py-2.5 text-sm weight-medium">
                    <div className="text-[var(--font-400)]">Status</div>
                    <div
                      className={cn(
                        "text-[#F96056]",
                        team_statusId?.length > 0
                          ? "cursor-pointer opacity-100"
                          : "cursor-not-allowed opacity-50"
                      )}
                      onClick={() => {
                        if (team_statusId?.length > 0) {
                          clearTeamStatus();
                        }
                      }}
                    >
                      Clear
                    </div>
                  </div>

                  {team_status?.map((s) => {
                    return (
                      <div
                        className={cn(
                          "w-full h-12 flex items-center gap-2.5 py-1 cursor-pointer pl-10"
                        )}
                        onClick={() => {
                          onTeamsStatusChange(s);
                        }}
                        key={s?.id}
                      >
                        <CheckBoxSqure
                          value={s?.isSelected}
                          onChange={(e) => {}}
                          className="size-4"
                        />
                        <p>{s?.label}</p>
                      </div>
                    );
                  })}
                </div>
              }
            >
              <div className="group/goal bg-[var(--channelButton)] flex items-center gap-2.5 px-2 py-1.5 rounded-[0.4vw] cursor-pointer">
                <span className="campaign-filters flex items-center">
                  Status
                </span>
                <div
                  className={cn(
                    "transition-transform duration-200 ease-linear"
                  )}
                >
                  <div
                    className={`border-[0.4vw] rounded-t-[0.2vw] border-transparent border-t-[#777] translate-y-[25%]`}
                  ></div>
                </div>
              </div>
            </Popover>

            <div
              className={cn(
                `group/status flex items-center gap-2.5 hover:bg-[var(--BG-25)] px-2.5 py-2.5 rounded-lg ${
                  allowAllClear()
                    ? "cursor-pointer opacity-100"
                    : "cursor-not-allowed opacity-50"
                }`
              )}
              onClick={() => {
                if (allowAllClear()) {
                  clearRoleList();
                  clearTeamStatus();
                }
              }}
            >
              <ClearFilters
                width={16}
                height={16}
                color={
                  allowAllClear() ? "var(--contentText)" : "var(--font-600)"
                }
              />
            </div>
          </div>
          <div className="  p-1 flex-row space-between gap-2 overflow-auto">
            {team_role?.map((s) => {
              if (s?.isSelected === false) return;
              return (
                <div
                  className={cn(
                    " flex items-center gap-2.5 p-1 rounded-[4px] font14px-500 text-[var(--textBlack)]  bg-[var(--BG-50)]"
                  )}
                  key={s?.id}
                >
                  <p>{s?.label}</p>
                  <span
                    className="cursor-pointer text-red-500"
                    onClick={() => {
                      onRoleChange(s);
                    }}
                  >
                    X
                  </span>
                </div>
              );
            })}
            {team_status?.map((s) => {
              if (s?.isSelected === false) return;
              return (
                <div
                  className={cn(
                    " flex items-center gap-2.5 p-1 rounded-[4px] font14px-500 text-[var(--textBlack)]  bg-[var(--BG-50)]"
                  )}
                  key={s?.id}
                >
                  <p>{s?.label}</p>
                  <span
                    className="cursor-pointer text-red-500"
                    onClick={() => {
                      onTeamsStatusChange(s);
                    }}
                  >
                    X
                  </span>
                </div>
              );
            })}
          </div>
        </div>
        <TeamsList
          activeNav={activeNav}
          teamsData={teamsData}
          setActiveTeam={setActiveTeam}
          activeTeam={activeTeam}
          teamMembers={teamMembers}
          showModal={showModal}
          handleDeleteTeams={handleDeleteTeams}
          handleEditTeams={handleEditTeams}
          handleRemoveMember={handleRemoveMember}
          handleCancelInvitation={handleCancelInvitation}
          editDeletePopover={editDeletePopover}
          setEditDeteletePopover={setEditDeteletePopover}
          handleActivateTeams={handleActivateTeams}
          multipleLeaders={multipleLeaders}
          multipleMembers={multipleMembers}
          updateScreenName={updateScreenName}
          inputValue={inputValue}
          setInputValue={setInputValue}
        />
      </div>
    </>
  );
};

export default TeamCreation;
